import {
  CircularProgress,
  Box,
  Grid,
  InputAdornment,
  Select,
  MenuItem,
  Typography,
  Button,
  RadioGroup,
  FormLabel,
  Radio,
  FormControlLabel,
  IconButton,
  Tooltip,
  ListItem,
} from "@mui/material";
import { Fragment, memo } from "react";
import CustomInput from "../../components/inputs/CustomInput";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import COUNTRY_CODES from "../../utils/CountryCode";
import GoogleAddress from "../../components/inputs/GoogleAddress";
import DynamicDataDropDown from "../../components/inputs/DynamicDataDropDown";
import { useDispatch, useSelector } from "react-redux";
import {
  COMPLAINER_TYPES,
  ENQUIRY_SOURCES,
  ENQUIRY_TYPES_IDENTIFIER,
  GENDER,
} from "../../utils/constants/lead.constants";
import { CheckCircle, ContactEmergency, People } from "@mui/icons-material";
import AreaCreateController from "../area/AreaCreateController";
import {
  addDistributionAreaData,
  fetchDistributionAreaAction,
} from "../../store/actions/distrubutionAreaAction";
import { openModal } from "../../store/actions/modalAction";
import DistributorListController from "./DistributorListController";
import FileInput from "../../components/inputs/FileInput";
import { ParentProductsList } from "../product/ProductDropDowns";
import { calculateAge } from "../../utils/helpers/lead.helper";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { titleCase } from "../../utils/helpers/main";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { USER_ROLES } from "../../utils/constants/main";
import { getProdutApi } from "../../apis/enquiry.api";

const SelectionButton = memo(({ title, active, onClick }) => (
  <Button
    disableElevation
    onClick={onClick}
    variant={active ? "contained" : "outlined"}
    sx={{ width: "100%", py: 3 }}
  >
    <Typography>{title}</Typography>
  </Button>
));

const TypeSelectionButton = memo(({ value, onChange = () => {} }) => {
  const { enquiryType } = useSelector((state) => state);
  console.log("first fields.type === enquiryType.data[4]", enquiryType);
  return (
    <>
      <Grid container columnSpacing={1}>
        {enquiryType?.data &&
          enquiryType?.data?.map((item) => (
            <Grid item md={12 / enquiryType?.data?.length} key={item._id}>
              <SelectionButton
                title={item.name}
                active={item?._id === value?._id}
                onClick={() => onChange(item)}
              />
            </Grid>
          ))}
      </Grid>
    </>
  );
});

const AddEnquiryUI = ({
  title,
  modalKey,
  defaulData,
  fields,
  setFields,
  loading,
  onSubmit,
}) => {
  const dispatch = useDispatch();

  const {
    communicationChannel,
    product,
    distributionArea,
    source,
    enquiryType,
  } = useSelector((state) => state);

  const handleAddBoxId = () => {
    setFields({
      ...fields,
      deviceIds: [
        ...fields.deviceIds,
        { product_id: "", box_id: "", problems: "" },
      ],
    });
  };

  const handleProblemChange = (index, value) => {
    const updatedDeviceIds = [...fields.deviceIds];
    updatedDeviceIds[index] = {
      ...updatedDeviceIds[index],
      problems: value,
    };

    setFields({
      ...fields,
      deviceIds: updatedDeviceIds,
    });
  };

  const handleBoxIdChange = (index, value) => {
    const updatedDeviceIds = [...fields.deviceIds];
    updatedDeviceIds[index] = {
      ...updatedDeviceIds[index],
      box_id: value,
    };

    setFields({
      ...fields,
      deviceIds: updatedDeviceIds,
    });
  };

  const handleProductChange = (index, value) => {
    const updatedDeviceIds = [...fields.deviceIds];
    updatedDeviceIds[index] = {
      ...updatedDeviceIds[index],
      product_id: value?._id,
    };

    setFields({
      ...fields,
      deviceIds: updatedDeviceIds,
    });
  };

  const handleRemoveBoxId = (indexToRemove) => {
    const updatedDeviceIds = fields.deviceIds.filter(
      (_, index) => index !== indexToRemove
    );

    setFields({
      ...fields,
      deviceIds: updatedDeviceIds,
    });
  };

  return (
    <>
      <CustomDialog
        id={modalKey}
        loading={loading}
        // dialogProps={{ sx: { position: "relative" } }}
        err={fields.err}
        onSubmit={onSubmit}
        title={`${title}`}
        closeText="Close"
        confirmText={`Submit`}
      >
        {loading && (
          <CenteredBox
            sx={{
              position: "absolute",
              height: "100%",
              width: "100%",
              top: "0px",
              left: "0px",
              zIndex: 11,
              background: "rgba(255,255,255,0.7)",
            }}
          >
            <CircularProgress />
          </CenteredBox>
        )}
        {
          <Box pt={2}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            ></Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Box sx={{ width: "100%" }}>
                  <DynamicDataDropDown
                    fullWidth
                    defaultValue={defaulData?.channel ?? null}
                    onChange={(e, val) =>
                      setFields({ ...fields, channel: val })
                    }
                    reducerDataObj={communicationChannel}
                    titleKey="channel_name"
                    valueKey="_id"
                    inputProps={{
                      label: "Communication Channel*",
                    }}
                  />
                </Box>
              </Grid>
              {fields.channel && (
                <>
                  <Grid item xs={12} md={12}>
                    <Typography mt={2} mb={1}>
                      Enquiry Type:
                    </Typography>
                    <TypeSelectionButton
                      value={fields.type}
                      onChange={(val) =>
                        setFields({
                          ...fields,
                          type: val,
                          source: null,
                          product: null,
                          area: null,
                        })
                      }
                    />
                    <Box mb={4} />
                  </Grid>
                  <></>
                  <Grid item xs={12} md={4}>
                    <CustomInput
                      margin="none"
                      autoFocus={true}
                      disabled={loading}
                      value={fields.first_name}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          first_name: e.target.value,
                        })
                      }
                      type="text"
                      label={"First Name*"}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <CustomInput
                      margin="none"
                      disabled={loading}
                      value={fields.middle_name}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          middle_name: e.target.value,
                        })
                      }
                      type="text"
                      label={"Middle Name"}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <CustomInput
                      margin="none"
                      disabled={loading}
                      value={fields.last_name}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          last_name: e.target.value,
                        })
                      }
                      type="text"
                      label={"Last Name"}
                    />
                  </Grid>

                  <Grid item xs={12} md={5}>
                    <CustomInput
                      margin="none"
                      disabled={loading}
                      value={fields.email}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          email: e.target.value,
                        })
                      }
                      type="email"
                      label={"Email"}
                    />
                  </Grid>
                  <Grid item xs={12} md={3.5}>
                    <CustomInput
                      margin="none"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Select
                              disableUnderline
                              value={fields.country_code}
                              onChange={(e) =>
                                setFields({
                                  ...fields,
                                  err: "",
                                  country_code: e.target.value,
                                })
                              }
                              variant="standard"
                              size="small"
                            >
                              {COUNTRY_CODES.map((item) => (
                                <MenuItem
                                  key={item.code}
                                  value={item.dial_code}
                                >
                                  {item.code}({item.dial_code})
                                </MenuItem>
                              ))}
                            </Select>
                          </InputAdornment>
                        ),
                      }}
                      disabled={loading}
                      value={fields.phone}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          phone: e.target.value,
                        })
                      }
                      type="tel"
                      label={"Phone No.*"}
                    />
                  </Grid>

                  <Grid item xs={12} md={3.5}>
                    <CustomInput
                      margin="none"
                      disabled={loading}
                      value={fields.other_phone}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          other_phone: e.target.value,
                        })
                      }
                      type="tel"
                      label={"Other Phone No"}
                    />
                  </Grid>
                  {(fields.type === enquiryType.data[1] ||
                    fields.type === enquiryType.data[3] ||
                    fields.type === enquiryType.data[4]) && (
                    <>
                      <Grid item xs={12} md={3.5}>
                        <DesktopDatePicker
                          sx={{ width: "18vw", height: "100%" }}
                          inputFormat="DD/MM/yyyy"
                          disableFuture
                          renderInput={(props) => <CustomInput {...props} />}
                          value={fields?.dob}
                          onChange={(val) => {
                            if (val && val.isValid()) {
                              const isoString = val.toISOString();
                              setFields({
                                ...fields,
                                err: "",
                                dob: isoString,
                                age: calculateAge(isoString),
                              });
                              // setIsAgeModified(false);
                            } else {
                              setFields({
                                ...fields,
                                err: "",
                                dob: "",
                                age: 0,
                              });
                            }
                          }}
                          label={"DOB"}
                        />
                      </Grid>

                      <Grid item xs={12} md={1.5}>
                        <CustomInput
                          disabled={true}
                          value={calculateAge(fields?.dob)}
                          nputLabelProps={{
                            shrink: true,
                          }}
                          autoFocus
                          onChange={(e) => {
                            setFields({ ...fields, age: e.target.value });
                          }}
                          onBlur={(e) => {
                            const dob = moment()
                              .set("date", 1)
                              .set("month", 5)
                              .add(-1 * e.target.value, "year");
                            setFields({
                              ...fields,
                              err: "",
                              dob: dob.toISOString(),
                            });
                          }}
                          type="number"
                          label={"Age"}
                        />
                      </Grid>
                      <Grid mt={2} p={2} md={7}>
                        <Box
                          p={"6px"}
                          sx={{
                            border: "1px solid #CCCCCC",
                            borderRadius: "8px",
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Box>
                            <FormLabel
                              disabled={loading}
                              id="demo-row-radio-buttons-group-label"
                            >
                              Gender*
                            </FormLabel>
                          </Box>
                          <Box
                            sx={{
                              // width: "1px",
                              // height: "20px",
                              backgroundColor: "navy",
                            }}
                          />

                          <Box>
                            <RadioGroup
                              sx={{ minHeight: "10px" }}
                              value={fields?.gender}
                              onChange={(e) =>
                                setFields({
                                  ...fields,
                                  err: "",
                                  gender: e.target.value,
                                })
                              }
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                            >
                              {Object.keys(GENDER).map((item) => (
                                <FormControlLabel
                                  disabled={loading}
                                  key={item}
                                  value={GENDER[item]}
                                  control={<Radio />}
                                  label={titleCase(item)}
                                />
                              ))}
                            </RadioGroup>
                          </Box>
                        </Box>
                      </Grid>
                    </>
                  )}
                  <Grid
                    item
                    xs={12}
                    md={
                      fields?.type?.identifier ===
                        ENQUIRY_TYPES_IDENTIFIER.INFORMATION ||
                      fields?.type?.identifier ===
                        ENQUIRY_TYPES_IDENTIFIER.PURCHASED
                        ? 6
                        : 12
                    }
                  >
                    <CustomInput
                      margin="none"
                      disabled={loading}
                      value={fields.address}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          address: e.target.value,
                        })
                      }
                      type="text"
                      label={"Address(Street / Village)"}
                    />
                  </Grid>

                  {fields?.type?.identifier &&
                    (fields?.type?.identifier ===
                      ENQUIRY_TYPES_IDENTIFIER.INFORMATION ||
                      fields?.type?.identifier ===
                        ENQUIRY_TYPES_IDENTIFIER.PURCHASED) && (
                      <Grid item xs={12} md={6}>
                        <DynamicDataDropDown
                          fullWidth
                          creatable
                          defaultValue={defaulData?.area ?? null}
                          onRefresh={() => {
                            dispatch(fetchDistributionAreaAction({}));
                          }}
                          onCreate={() => {
                            dispatch(
                              openModal(
                                <AreaCreateController
                                  callBack={(response) => {
                                    dispatch(addDistributionAreaData(response));
                                  }}
                                />,
                                "sm",
                                false,
                                "area",
                              ),
                            );
                          }}
                          defaultVal={fields.area}
                          key={fields.type?._id}
                          onChange={(e, val) =>
                            setFields({ ...fields, area: val })
                          }
                          reducerDataObj={distributionArea}
                          titleKey="area_name"
                          valueKey="_id"
                          inputProps={{
                            label: "Area*",
                          }}
                          renderOption={(props, option) => (
                            <MenuItem {...props}>
                              {" "}
                              <ContactEmergency
                                fontSize="inherit"
                                color={
                                  option?.has_a_distributor ? "success" : "grey"
                                }
                              />{" "}
                              &nbsp;&nbsp;{option["area_name"]}
                            </MenuItem>
                          )}
                        />
                      </Grid>
                    )}

                  <Grid item xs={12} md={12}>
                    <GoogleAddress
                      defaultAddress={{
                        postCode: fields.pin,
                        state: fields.state,
                        locality: fields.city,
                        country: fields.country,
                      }}
                      onChange={(val) => {
                        setFields({
                          ...fields,
                          pin: val.postCode,
                          state: val.state,
                          city: val.locality,
                          country: val.country,
                        });
                      }}
                    />
                    <Box mb={2}></Box>
                  </Grid>

                  {fields?.type?.identifier &&
                    (fields.type?.identifier == ENQUIRY_TYPES_IDENTIFIER.CSR ||
                      fields.type?.identifier ==
                        ENQUIRY_TYPES_IDENTIFIER.DEALERSHIP ||
                      fields.type?.identifier ==
                        ENQUIRY_TYPES_IDENTIFIER.PURCHASED ||
                      fields.type?.identifier ==
                        ENQUIRY_TYPES_IDENTIFIER.INFORMATION) && (
                      <>
                        <Grid
                          item
                          xs={12}
                          md={
                            fields.source?.identifier !=
                            ENQUIRY_SOURCES.REFERENCE
                              ? 12
                              : 6
                          }
                        >
                          <DynamicDataDropDown
                            fullWidth
                            defaultValue={fields.source}
                            key={fields.type?._id}
                            onChange={(e, val) =>
                              setFields({ ...fields, source: val })
                            }
                            reducerDataObj={source}
                            titleKey="name"
                            valueKey="_id"
                            inputProps={{
                              label: "Source Of Enquiry*",
                            }}
                          />
                        </Grid>
                        {fields.source?.identifier ==
                          ENQUIRY_SOURCES.REFERENCE && (
                          <>
                            <Grid item xs={12} md={3}>
                              <CustomInput
                                margin="none"
                                disabled={loading}
                                value={fields.referral_name}
                                onChange={(e) =>
                                  setFields({
                                    ...fields,
                                    err: "",
                                    referral_name: e.target.value,
                                  })
                                }
                                type="text"
                                label={"Referral Name"}
                              />
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <CustomInput
                                margin="none"
                                disabled={loading}
                                value={fields.referral_phone}
                                onChange={(e) =>
                                  setFields({
                                    ...fields,
                                    err: "",
                                    referral_phone: e.target.value,
                                  })
                                }
                                type="text"
                                label={"Referral Phone No"}
                              />
                            </Grid>
                          </>
                        )}
                      </>
                    )}

                  {fields?.type?.identifier &&
                    (fields?.type?.identifier ===
                      ENQUIRY_TYPES_IDENTIFIER.INFORMATION ||fields?.type?.identifier ===
                      ENQUIRY_TYPES_IDENTIFIER.COMPLAIN ||
                      fields?.type?.identifier ===
                        ENQUIRY_TYPES_IDENTIFIER.PURCHASED) && (
                      <>
                        <Grid item xs={12} md={6}>
                          <ParentProductsList
                            fullWidth
                            defaultValue={defaulData?.product ?? null}
                            key={fields.type?._id}
                            onChange={(e, val) =>
                              setFields({ ...fields, product: val })
                            }
                          />
                        </Grid>
                      </>
                    )}

                  {fields?.product?.is_medical_product &&
                    fields?.type?.identifier !==
                      ENQUIRY_TYPES_IDENTIFIER.COMPLAIN && (
                      <Grid item xs={12}>
                        <FileInput
                          sx={{ width: "100%" }}
                          onChange={(file) => {
                            setFields({ ...fields, audiogram: file });
                          }}
                          defaults={fields.audiogram ? [fields.audiogram] : []}
                          accept=".pdf"
                          title="Upload Audiogram"
                          subTitle="Only pdf files are allowed! less than 1 MB"
                        />
                      </Grid>
                    )}

                  {/* {fields.type === enquiryType.data[4] &&
                    <Grid p={2} md={6}>
                      <Box
                        p={"6px"}
                        sx={{
                          border: "1px solid #CCCCCC",
                          borderRadius: "8px",
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Box>
                          <FormLabel
                            disabled={loading}
                            id="demo-row-radio-buttons-group-label"
                          >
                            Complainer*
                          </FormLabel>
                        </Box>
                        <Box
                          sx={{
                            // width: "1px",
                            // height: "20px",
                            backgroundColor: "navy",
                          }}
                        />

                        <Box>
                          <RadioGroup
                            sx={{ minHeight: "10px" }}
                            value={fields?.complainerType}
                            onChange={(e) =>
                              setFields({
                                ...fields,
                                err: "",
                                complainerType: Number(e.target.value),
                              })
                            }
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                          >
                            {Object.keys(COMPLAINER_TYPES).map((item) => (
                              <FormControlLabel
                                disabled={loading}
                                key={item}
                                value={COMPLAINER_TYPES[item]}
                                control={<Radio />}
                                label={titleCase(item)}
                              />
                            ))}
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Grid>} */}

                  {/* {fields.type === enquiryType.data[4] && (
                    <Grid item md={12} sm={12} xs={12}>
                      <Box
                        p={2}
                        sx={{
                          display: "flex",
                          height: "auto",
                          border: "1px solid #CCCCCC",
                          flexDirection: "column",
                          borderRadius: "8px",
                        }}
                      >
                        <Box mb={2} sx={{ display: "flex", width: "100%", flexDirection: "row" }}>
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                          >
                            <Typography variant="h6" color={"primary"}>
                              Device Id & Problem:
                            </Typography>
                          </Box>
                        </Box>

                        {fields?.deviceIds?.map((item, index) => (
                          <Box
                            key={index}
                            p={2}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              gap: 2,
                            }}
                          >

                            <AsyncDropDown
                              // defaultVal={
                              //   fields.product_id?._id ? {
                              //     _id: fields.product_id?._id,
                              //     name: fields.product_id?.name,
                              //   } : null
                              // }
                              lazyFun={async (para) => await getProdutApi({ ...para, allStatus: true })}
                              OptionComponent={({ option, ...rest }) => {
                                return <ListItem {...rest}>{option.name}</ListItem >
                              }}
                              value={item?.product_id}
                              onChange={async (changedVal) => {
                                handleProductChange(index, changedVal);
                              }}
                              titleKey={'name'}
                              valueKey={"_id"}
                              InputComponent={(params) => <CustomInput placeholder={"Select Product"} {...params} margin="none" />}
                            />

                            <CustomInput
                              margin="none"
                              label={`Device Id ${index + 1}`}
                              value={item.box_id}
                              onChange={(e) => handleBoxIdChange(index, e.target.value)}
                              fullWidth
                              type="text"
                            />

                            <CustomInput
                              margin="none"
                              label={`Problem ${index + 1}`}
                              value={item.problems}
                              onChange={(e) => handleProblemChange(index, e.target.value)}
                              fullWidth
                              type="text"
                            />

                            {fields.deviceIds.length > 1 && (
                              <Tooltip title="Remove Field" arrow>
                                <IconButton onClick={() => handleRemoveBoxId(index)} color="error">
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        ))}

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Tooltip title="Add Another Id" arrow>
                            <IconButton size="inherit" onClick={handleAddBoxId}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "50%",
                                  border: "2px solid #808080",
                                }}
                              >
                                <AddIcon fontSize="medium" />
                              </Box>
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Grid>
                  )} */}

                  {
                    <Grid item xs={12}>
                      <CustomInput
                        margin="none"
                        multiline
                        rows={3}
                        disabled={loading}
                        value={fields.remarks}
                        onChange={(e) =>
                          setFields({
                            ...fields,
                            err: "",
                            remarks: e.target.value,
                          })
                        }
                        type="text"
                        label={"Summary Of Call*"}
                      />
                    </Grid>
                  }
                </>
              )}
            </Grid>
          </Box>
        }
      </CustomDialog>
    </>
  );
};
export default memo(AddEnquiryUI);
